<template>
  <div class="container-fluid" data-spy="scroll">
    <nav
      class="navbar navbar-expand-lg navbar-dark border"
      style="background: #336699; color: #ffffff"
    >
      <div class="container-fluid" style="background: #336699; color: #ffffff">
        <a
          class="navbar-brand"
          href="#"
          style="background: #336699; color: #ffffff"
          >HC</a
        >
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse"
          id="navbarNavDropdown"
          style="background: #336699; color: #ffffff"
        >
          <ul class="navbar-nav" style="background: #336699; color: #ffffff">
            <li class="nav-item" v-if="verpagina != 0" @click="menuCabecera(1)">
              <a
                class="nav-link active"
                aria-current="page"
                href="#"
                style="background: #336699; color: #ffffff"
                >Listar Historia Clínica</a
              >
            </li>
            <li class="nav-item" v-if="verpagina == 0" @click="menuCabecera(2)">
              <a
                class="nav-link"
                href="#"
                style="background: #336699; color: #ffffff"
                >Apertura Historia Clínica</a
              >
            </li>
            <!--
            <li class="nav-item">
              <a class="nav-link" href="#" style="background: #336699; color:#ffffff">Pricing</a>
            </li>
            -->
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <div class="container-fluid" data-spy="scroll">
    <div class="card bg-white">
      <template v-if="verpagina == 0">
        <div class="card-body">
          <div class="form-group row">
            <!-- inicio
            <div class="container">
              <div class="card">
                -->
            <!--
                <div class="card-header border text-start fw-bold">
                  -->
            <div class="card-body">
              <div class="row content">
                <div class="form-group row input-group col-md-12">
                  <div class="input-group col-md-12">
                    <div class="col-md-6 text-start">
                      <label style="width: 100%">Ingresar&nbsp;búsqueda:</label>
                      <input
                        type="text"
                        class="inputText border col-md-10"
                        v-model="buscarlike"
                        placeholder="Ingresar búsqueda, apellidos/cédula"
                        style="font-size: 12px; width: 100%; height: 32px"
                        @keyup.enter="listarHC()"
                        title="Ingresar apellidos/cédula"
                      />
                    </div>

                    <div>
                      <div
                        class="text-start"
                        style="
                          height: 25px;
                          font-size: 11px;

                          padding-top: 1px;
                          font-weight: bold;
                        "
                      >
                        &nbsp;
                      </div>
                      <button
                        type="submit"
                        @click="listarHC()"
                        class="btn btn-secondary"
                        style="font-size: 12px; height: 32px"
                      >
                        <i class="fa fa-search"></i> Buscar</button
                      >&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--
                </div>
                -->

            <div class="card-body border">
              <div class="table-responsive">
                <table class="table table-bordered table-sm" width="100%">
                  <thead>
                    <tr>
                      <th>Acciones</th>
                      <!--<th>Código HC</th>-->
                      <th>Identificación</th>
                      <th>Apellidos</th>
                      <th>Nombres</th>
                      <!--<th>Estado</th>-->
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(formul, index) in arrayPromocionesAll"
                      :key="index"
                    >
                      <td>
                        <div
                          class="dropdown"
                          style="background: #ffffff; color: #ffffff"
                        >
                          <button
                            class="btn btn-secondary dropdown-toggle"
                            type="button"
                            id="dropdownMenu2"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style="
                              background: #336699;
                              color: #ffffff;
                              font-size: 12px;
                            "
                          >
                            Acciones
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenu2"
                            style="font-size: 13px"
                          >
                            <li>
                              <button
                                class="dropdown-item"
                                type="button"
                                @click="editarHC(formul)"
                              >
                                <i class="fa fa-list-alt"></i>&nbsp;Historial
                                Clínico
                              </button>
                            </li>
                            <!-- <li><button class="dropdown-item" type="button"><i class="fas fa-door-closed"></i>&nbsp;Finalizar</button></li> -->
                            <li v-if="rol == 2 || rol == 1">
                              <button
                                class="dropdown-item"
                                type="button"
                                @click="generarPDFHCT(formul)"
                              >
                                <i class="fa fa-book"></i>&nbsp;Generar
                                Historial clínico
                              </button>
                            </li>
                            <li v-if="rol == 2 || rol == 1">
                              <button
                                class="dropdown-item"
                                type="button"
                                @click="downloadHCTodo(formul, 0)"
                              >
                                <i class="fa fa-download"></i>&nbsp;Descargar
                                PDF
                              </button>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <!--<td v-text="formul.id"></td>-->
                      <td class="text-start" v-text="formul.numdocumento"></td>
                      <td class="text-start" v-text="formul.apellidos"></td>
                      <td class="text-start" v-text="formul.nombres"></td>

                      <!--<td v-text="formul.estado"></td> -->
                    </tr>
                  </tbody>
                </table>
                <div v-if="arrayPromocionesAll.length < 5">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>

                <nav
                  v-if="paginasTotal > 0"
                  aria-label="Page navigation example"
                >
                  <ul class="pagination">
                    <li class="page-item">
                      <a class="page-link" href="#" @click="prevPage()"
                        ><i class="fas fa-fast-backward"></i
                      ></a>
                    </li>
                    <li
                      v-for="n in paginasTotal"
                      :key="n"
                      class="page-item list-group-item-secondary"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click="fitrarPromociones(n)"
                        >{{ n }}</a
                      >
                    </li>

                    <li class="page-item">
                      <a class="page-link" href="#" @click="nextPage()"
                        ><i class="fas fa-fast-forward"></i
                      ></a>
                    </li>
                    <li>
                      <a class="page-link" href="#">
                        &nbsp;&nbsp;<i></i>Página ({{ paginaActiva }})
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            <div class="card-footer text-muted justify-content-md-end">
              <div class="form-control-sm row" style="height: 1px">
                <div class="col-md-10 text-center"></div>
              </div>
            </div>

            <!-- fin
              </div>
            </div>
            -->
          </div>
        </div>
      </template>
      <!-- Página uno -->
      <template v-if="verpagina == 1">
        <div class="card-body">
          <div class="form-group row">
            <!-- inicia
            <div class="container">
              <div class="card">
                -->

            <div class="card-header border text-start fw-bold">
              <!-- <h6>Datos del paciente</h6>-->
              <ul class="nav nav-tabs">
                <li class="nav-item" @click="cargarSeccion(3)">
                  <a class="nav-link active" v-if="seccionesPagina == 3"
                    >Históricos</a
                  >
                  <a class="nav-link" v-else>Históricos</a>
                </li>
                <li class="nav-item" @click="cargarSeccion(1)">
                  <a
                    class="nav-link active"
                    aria-current="page"
                    v-if="seccionesPagina == 1"
                    >Paciente</a
                  >
                  <a class="nav-link" aria-current="page" v-else>Paciente</a>
                </li>
                <li class="nav-item" @click="cargarSeccion(2)">
                  <a class="nav-link active" v-if="seccionesPagina == 2"
                    >Nuevo</a
                  >
                  <a class="nav-link" v-else>Nuevo</a>
                </li>

                <li class="nav-item" @click="cargarSeccion(4)">
                  <a class="nav-link" v-if="seccionesPagina == 4"
                    >Val. Terap.</a
                  >
                  <a class="nav-link" v-else>Val. Terap.</a>
                </li>

                <li
                  class="nav-item"
                  @click="cargarSeccion(5)"
                  v-if="(rol == 4 || rol == 1) && codigohc != 0"
                >
                  <a class="nav-link" v-if="seccionesPagina == 6">Recetas</a>
                  <a class="nav-link" v-else>Recetas</a>
                </li>

                <!--
                    <li class="nav-item">
                      <a
                        class="nav-link disabled"
                        href="#"
                        tabindex="-1"
                        aria-disabled="true"
                        >Disabled</a
                      >
                    </li>
                    -->
              </ul>
            </div>
            <!--BUSCAR PACIENTE Y CREAR HC-->
            <div class="card-body border" v-if="seccionesPagina == 1">
              <div class="form-control-sm row">
                <div class="col-md-2 text-end">
                  <label class=""> Buscar:</label>
                </div>
                <div class="col-md-4">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    v-model="numdocumento"
                    placeholder="Ingrese número de cédula a buscar"
                    required
                    @keyup.enter="buscarPacienteHC()"
                  />
                </div>
                <div class="col-md-2">
                  <button
                    type="submit"
                    @click="buscarPacienteHC()"
                    class="btn btn-secondary"
                    style="font-size: 12px; height: 32px"
                  >
                    <i class="fa fa-search"></i> Buscar</button
                  >&nbsp;&nbsp;
                </div>
                <div class="col-md-3" v-if="arrayHCPacienteAll.length == 0">
                  <button
                    type="submit"
                    @click="registrarHC()"
                    class="btn btn-secondary"
                    style="font-size: 12px; height: 32px"
                  >
                    <i class="fa fa-search"></i> Apertura inicial</button
                  >&nbsp;&nbsp;
                </div>
              </div>
              <hr style="height: 1px" />

              <div class="form-control-sm row">
                <div class="col-md-1 text-end">
                  <label class="">Apellidos: </label>
                </div>
                <div class="col-md-4">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Apellidos del paciente"
                    v-model="apellidos"
                    readonly
                  />
                </div>
                <div class="col-md-1 text-end">
                  <label class="">Nombres: </label>
                </div>
                <div class="col-md-4">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Nombres del paciente"
                    v-model="nombres"
                    readonly
                  />
                </div>
                <div class="col-md-1 text-end">
                  <label class="">Edad: </label>
                </div>
                <div class="col-md-1">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Edad"
                    v-model="edad"
                    readonly
                  />
                </div>

                <div class="col-md-1 text-end">
                  <label class="">Genero: </label>
                </div>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Genero"
                    v-model="genero"
                    readonly
                  />
                </div>
                <!--
                    <div class="col-md-1 text-end">
                      <label class="">Teléfono: </label>
                    </div>
                    <div class="col-md-3">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="Teléfono"
                        v-model="telefono"
                        readonly
                      />
                    </div>
                    <div class="col-md-1 text-end">
                      <label class="">Celular: </label>
                    </div>
                    <div class="col-md-3">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="Celular"
                        v-model="celular"
                        readonly
                      />
                    </div>
                    <div class="col-md-1 text-end">
                      <label class="">Llamar: </label>
                    </div>
                    <div class="col-md-3">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="Telf. emergencia"
                        v-model="telefonoemergencia"
                        readonly
                      />
                    </div>
                    <div class="col-md-1 text-end">
                      <label class="">Correo: </label>
                    </div>
                    <div class="col-md-3">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="E-mail"
                        v-model="correo"
                        readonly
                      />
                    </div>
                    -->
              </div>
            </div>
            <!--PARA CREAR NUEVO-->
            <div class="card-body border" v-if="seccionesPagina == 2">
              <div class="form-control-sm row">
                <div class="col-md-1 text-end">{{ codigohc }}</div>
                <div class="col-md-2 text-end">
                  <label class="">Código HC: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Código"
                    v-model="codigohc"
                    readonly
                    title="Código del caso."
                  />
                </div>

                <div class="col-md-1 text-end">
                  <label class="">Estado: </label>
                </div>
                <div class="col-md-1">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Estado"
                    v-model="estado"
                    readonly
                  />
                </div>
                <div class="col-md-2 text-end">
                  <label class="">Fecha registro: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="date"
                    class="form-control form-control-sm inputText"
                    v-model="fecharegistro"
                    max="2100-12-31T23:59"
                  />
                </div>
              </div>
              <div style="height: 1px">
                <hr />
              </div>

              <div>
                <label class="fw-bold" style="font-size: 12px"
                  >Exploración física</label
                >
              </div>

              <div class="form-control-sm row">
                <div class="col-md-2 text-end">
                  <label class="">Seguro Médico: </label>
                </div>
                <div class="col-md-2">
                  <select
                    class="form-select form-select-sm form-control inputText"
                    v-model="seguromedico"
                    required
                  >
                    <option value="0" disabled>Seleccione</option>
                    <option value="SI">SI</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
                <div class="col-md-2 text-end">
                  <label class="">Aseguradora: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Aseguradora "
                    v-model="aseguradora"
                    required
                  />
                </div>
                <div class="col-md-2 text-end">
                  <label class="">Num. seguro: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Num. seguro"
                    v-model="numeroseguro"
                    required
                  />
                </div>
              </div>
              <div class="form-control-sm row">
                <div class="col-md-1 text-end">
                  <label class="" v-if="genero == 'Femenino'">Embarazo: </label>
                </div>
                <div class="col-md-2">
                  <select
                    v-if="genero == 'Femenino'"
                    class="form-select form-select-sm form-control inputText"
                    v-model="embarazo"
                    required
                  >
                    <option value="NO">NO</option>
                    <option value="SI">SI</option>
                  </select>
                </div>
                <div class="col-md-1 text-end">
                  <label class="" v-if="genero == 'Femenino'">No hijos: </label>
                </div>
                <div class="col-md-2">
                  <input
                    v-if="genero == 'Femenino'"
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="No hijos"
                    v-model="numhijos"
                    required
                  />
                </div>
                <div class="col-md-4"></div>
                <div class="col-md-2 text-start">
                  <label
                    class="border"
                    @click="abrirModalSignosVitales(2)"
                    style="color: #ff7f00"
                    >&nbsp;&nbsp;Signos vitales&nbsp;<i
                      class="fa fa-heart"
                      aria-hidden="true"
                    ></i
                    >&nbsp;&nbsp;&nbsp;</label
                  >
                </div>
              </div>
              <div class="form-control-sm row">
                <div class="col-md-2 text-end">
                  <label class="">Motivo de consulta: </label>
                </div>
                <div class="col-md-4">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Motivo de consulta"
                    v-model="nombreproceso"
                    required
                  />
                </div>
                <div class="col-md-3 text-end">
                  <label class="">Fecha inicio sintomas: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="date"
                    class="form-control form-control-sm inputText"
                    v-model="fechainiciosintomas"
                    required
                  />
                </div>
                <div class="col-md-2 text-end">
                  <label class="">Diagnóstico CI E10: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="CI E10"
                    v-model="diagnosticocie"
                    required
                  />
                </div>
                <div class="col-md-2 text-end">
                  <label class="">Diagnóstico gral.: </label>
                </div>
                <div class="col-md-5">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Diagnóstico general"
                    v-model="causageneral"
                    required
                  />
                </div>
                <div class="col-md-2 text-end">
                  <label class="">Médico remitente: </label>
                </div>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Médico remitente"
                    v-model="medicoremitente"
                    required
                  />
                </div>
              </div>
              <div style="height: 1px">
                <hr />
              </div>

              <div>
                <label class="fw-bold" style="font-size: 12px"
                  >Antecedentes</label
                >
              </div>

              <div class="form-control-sm row">
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Diabetes"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Diabetes"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Diabetes">Diabetes</label>
                </div>

                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Alergia"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Alergia"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Alergia">Alergia</label>
                </div>

                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="HTA"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="HTA"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="HTA">HTA</label>
                </div>

                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Cáncer"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Cáncer"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Cáncer">Cáncer</label>
                </div>
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Transfusiones"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Transfusiones"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Transfusiones">Transfusiones</label>
                </div>
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Encames"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Encames"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Encames">Encames</label>
                </div>
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Reumatismos"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Reumatismos"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Reumatismos">Reumatismos</label>
                </div>

                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Cardiopatías"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Cardiopatías"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Cardiopatías">Cardiopatías</label>
                </div>
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Cirugías"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Cirugías"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Medicity">Cirugías</label>
                </div>
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Accidentes"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Accidentes"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Accidentes">Accidentes</label>
                </div>
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Fracturas"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Fracturas"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Fracturas">Fracturas</label>
                </div>
                <div class="col-md-1 text-end">
                  <input
                    type="checkbox"
                    id="Otros"
                    style="display: inline-flex"
                    v-model="checkantecedentes"
                    value="Otros"
                  />
                </div>
                <div class="col-md-1 text-start">
                  <label class="" for="Otros">OTROS</label>
                </div>
              </div>
              <div class="form-control-sm row">
                <div class="col-md-4 text-end">
                  <label class="">Antecedentes patológicos adicionales: </label>
                  <label class="">Descripción de los más criticos: </label>
                </div>

                <div class="col-md-8 text-end">
                  <textarea
                    class="textareaAntec"
                    v-model="antecedentespatologicos"
                    placeholder="Antecedentes patológicos."
                  ></textarea>
                </div>
              </div>

              <div class="form-control-sm row">
                <div class="col-md-4 text-end">
                  <label class="">Antecedentes - problema: </label>
                  <textarea
                    class="textarea"
                    v-model="antecedentestratamiento"
                    placeholder="Antecedentes tratamiento."
                  ></textarea>
                </div>

                <div class="col-md-4 text-end">
                  <label class="">Valoración: </label>
                  <textarea
                    class="textarea"
                    rows="3"
                    cols="135"
                    v-model="valoracion"
                    placeholder="Valoración."
                  ></textarea>
                </div>
                <div class="col-md-4 text-end">
                  <label class="">Tratamiento: </label>
                  <textarea
                    class="textarea"
                    rows="3"
                    cols="135"
                    v-model="tratamientosprevios"
                    placeholder="Tratamientos previos."
                  ></textarea>
                </div>
              </div>
            </div>
            <!--PARA LISTAR HISTORICOS-->
            <div class="card-body border" v-if="seccionesPagina == 3">
              <div class="table-responsive">
                <table class="table table-bordered table-sm" width="100%">
                  <thead>
                    <tr>
                      <th>Acciones</th>
                      <th>Valoraciones</th>
                      <th>Registro</th>
                      <th>Identificación</th>
                      <th>Nombres</th>
                      <th>Motivo</th>
                      <th>Código CIE</th>
                      <th>Diagnóstico</th>
                      <th>Fecha</th>
                      <th>Usuario<br />Registra</th>
                      <th>Estado</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(formul, index) in arrayHCPacienteAll"
                      :key="index"
                    >
                      <td>
                        <div
                          class="dropdown"
                          style="background: #ffffff; color: #ffffff"
                        >
                          <button
                            class="btn btn-secondary dropdown-toggle"
                            type="button"
                            id="dropdownMenu2"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style="
                              background: #336699;
                              color: #ffffff;
                              font-size: 12px;
                            "
                          >
                            Acciones
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenu2"
                            style="font-size: 13px"
                          >
                            <!-- control de solo usuarios admin  y quien crea
                            <li
                              v-if="usuario == formul.usuario || rol == 1"
                              @click="editarHCProceso(formul, 1)"
                            >
                              <button class="dropdown-item" type="button">
                                <i class="fas fa-pencil-alt"></i>&nbsp;Editar
                              </button>
                            </li>
                          -->
                            <li @click="editarHCProceso(formul, 1)">
                              <button class="dropdown-item" type="button">
                                <i class="fas fa-pencil-alt"></i
                                >&nbsp;Ver-Editar
                              </button>
                            </li>
                            <li @click="editarHCProceso(formul, 2)">
                              <button class="dropdown-item" type="button">
                                <i class="fa fa-bars" aria-hidden="true"></i
                                >&nbsp;Valoraciones
                              </button>
                            </li>

                            <li v-if="rol == 2 || rol == 1">
                              <button
                                class="dropdown-item"
                                type="button"
                                @click="generarPDFHCI(formul)"
                              >
                                <i class="fa fa-book"></i>&nbsp;Generar reporte
                              </button>
                            </li>
                            <li v-if="rol == 2 || rol == 1">
                              <button
                                class="dropdown-item"
                                type="button"
                                @click="downloadHCTodo(formul, formul.id)"
                              >
                                <i class="fa fa-download"></i>&nbsp;Descargar
                                PDF
                              </button>
                            </li>
                            <li>
                              <hr />
                            </li>
                            <li @click="finalizarProceso(formul, 1)">
                              <button class="dropdown-item" type="button">
                                <i class="fa fa-check" aria-hidden="true"></i
                                >&nbsp;Finalizar
                              </button>
                            </li>
                            <li @click="finalizarProceso(formul, 2)">
                              <button class="dropdown-item" type="button">
                                <i class="fa fa-check" aria-hidden="true"></i
                                >&nbsp;Cancelar
                              </button>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td>
                        <button
                          @click="editarHCProceso(formul, 2)"
                          class="border"
                          type="button"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i
                            class="fa fa-heartbeat"
                            aria-hidden="true"
                            style="color: #b81313"
                          ></i
                          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </button>
                      </td>
                      <td v-text="formul.id"></td>
                      <td v-text="formul.numdocumento" class="text-start"></td>
                      <td
                        v-text="formul.apellidosnombres"
                        class="text-start"
                      ></td>
                      <td v-text="formul.nombreproceso" class="text-start"></td>
                      <td v-text="formul.diagnosticocie"></td>
                      <td v-text="formul.causageneral" class="text-start"></td>
                      <td v-text="formul.fecharegistro" class="text-start"></td>
                      <td v-text="formul.usuario"></td>
                      <td v-text="formul.estado"></td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="arrayHCPacienteAll.length < 5">
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>

                <nav
                  v-if="paginasTotal > 0"
                  aria-label="Page navigation example"
                >
                  <ul class="pagination">
                    <li class="page-item">
                      <a class="page-link" href="#" @click="prevPage()"
                        ><i class="fas fa-fast-backward"></i
                      ></a>
                    </li>
                    <li
                      v-for="n in paginasTotal"
                      :key="n"
                      class="page-item list-group-item-secondary"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click="fitrarPromociones(n)"
                        >{{ n }}</a
                      >
                    </li>

                    <li class="page-item">
                      <a class="page-link" href="#" @click="nextPage()"
                        ><i class="fas fa-fast-forward"></i
                      ></a>
                    </li>
                    <li>
                      <a class="page-link" href="#">
                        &nbsp;&nbsp;<i></i>Página ({{ paginaActiva }})
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <!--VALORACIONES-->
            <div class="card-body border" v-if="seccionesPagina == 4">
              <div class="col-md-12 text-start">
                <!--<label>Problema/Causa:&nbsp;{{codigohc}}-{{ nombreproceso }}</label>-->
                <label>Diagnóstico:&nbsp;{{ causageneral }}</label>
              </div>
              <div class="form-control-sm row">
                <div class="col-md-6 text-start">
                  <label
                    class="border"
                    @click="abrirOpcionesValoracion(0)"
                    style="color: #ff7f00"
                    >&nbsp;&nbsp;Diag. general&nbsp;<i
                      class="fa fa-tasks"
                      aria-hidden="true"
                    ></i
                    >&nbsp;&nbsp;&nbsp;</label
                  >
                  <label
                    class="border"
                    @click="abrirOpcionesValoracion(1)"
                    style="color: #ff7f00"
                    >&nbsp;&nbsp;Visualizar&nbsp;<i
                      class="fa fa-tasks"
                      aria-hidden="true"
                    ></i
                    >&nbsp;&nbsp;&nbsp;</label
                  >
                  <label
                    v-if="estado == 'ACTIVO'"
                    class="border"
                    @click="abrirOpcionesValoracion(2)"
                    style="color: #ff7f00"
                    >&nbsp;&nbsp;Nuevo&nbsp;<i
                      class="fa fa-window-restore"
                      aria-hidden="true"
                    ></i
                    >&nbsp;&nbsp;&nbsp;</label
                  >
                  <label
                    v-if="estadoValoracion == 2"
                    class="border"
                    @click="abrirModalSignosVitales(4)"
                    style="color: #ff7f00"
                    >&nbsp;&nbsp;Signos vitales&nbsp;<i
                      class="fa fa-heart"
                      aria-hidden="true"
                    ></i
                    >&nbsp;&nbsp;&nbsp;</label
                  >
                </div>
              </div>
              <!--Visualizar valoraciones-->
              <template v-if="estadoValoracion == 0">
                <div class="form-control-sm row">
                  <div class="contenidoDiv">
                    <div
                      class="col-md-12 row"
                      style="color: #000000; font-size: 12px"
                    >
                      <div class="col-md-6 text-end">
                        <label class="border text-end"
                          >&nbsp;Fecha:&nbsp;{{
                            fecharegistroGral
                          }}&nbsp;&nbsp; </label
                        >&nbsp;
                        <label class="border"
                          >&nbsp;Usuario:&nbsp;{{ usuarioGral }}&nbsp; </label
                        >&nbsp;&nbsp;
                      </div>
                    </div>
                    <div class="col-md-12 text-start">
                      <label class="fw-bold">Antecedentes - problema: </label>
                      <textarea
                        class="textarea"
                        v-model="antecedentestratamientoGral"
                        placeholder="Tratamiento por sesión."
                        :disabled="disabledValoracion"
                      ></textarea>
                    </div>
                    <div class="col-md-12 text-start">
                      <label class="fw-bold">Valoración: </label>

                      <textarea
                        class="textarea"
                        v-model="valoracionGral"
                        placeholder="Valoración por sesión."
                        :disabled="disabledValoracion"
                      ></textarea>
                    </div>

                    <div class="col-md-12 text-start">
                      <label class="fw-bold">Tratamiento: </label>
                      <textarea
                        class="textarea"
                        v-model="tratamientospreviosGral"
                        placeholder="Tratamiento por sesión."
                        :disabled="disabledValoracion"
                      >
                      </textarea>
                    </div>

                    <div class="col-md-4"></div>
                    <!--
                        <div style="height: 10px">
                          <hr />
                        </div>
                        -->
                  </div>
                </div>
              </template>
              <!--Visualizar valoraciones-->
              <template v-if="estadoValoracion == 1">
                <div class="form-control-sm row">
                  <div
                    class="contenidoDiv"
                    v-for="(formP, index) in arrayHCPProcesoAll"
                    :key="index"
                  >
                    <div
                      class="col-md-12 row"
                      style="color: #000000; font-size: 12px"
                    >
                      <div class="col-md-6 text-start">
                        <label class="border" style="color: #336699">
                          {{
                            formP.id
                          }}&nbsp;Sig.&nbsp;Vitales:&nbsp;&nbsp;FC:&nbsp;
                          {{ formP.frecuenciacardica }}&nbsp;&nbsp;
                          &nbsp;TA.SYS:&nbsp;{{
                            formP.tensionarterialsist
                          }}&nbsp;&nbsp; &nbsp;TA.DIA:&nbsp;{{
                            formP.tensionarterialdiast
                          }}&nbsp;&nbsp; &nbsp;FR:&nbsp;{{
                            formP.frecuenciarespiratoria
                          }}&nbsp;&nbsp; &nbsp;SO2:&nbsp;{{
                            formP.saturacionoxigeno
                          }}&nbsp;&nbsp; &nbsp;T:&nbsp;{{
                            formP.temperatura
                          }}&nbsp;&nbsp; </label
                        >&nbsp;&nbsp;
                        <!-- 
                          <label
                          v-if="rol == 4" 
                          class="border"
                          style="color: #336699"
                          @click="generarPDFReceta(formP, 0)"
                        >
                        -->
                        <label
                          class="border"
                          style="color: #336699"
                          @click="generarPDFReceta(formP, 0)"
                        >
                          &nbsp;Receta:&nbsp;
                          <!--{{numeroreceta}} -->
                          &nbsp;&nbsp;&nbsp;
                          <i class="fa fa-bars" aria-hidden="true"></i
                          >&nbsp;&nbsp;
                        </label>
                      </div>
                      <div class="col-md-6 text-end">
                        <label class="border text-end"
                          >&nbsp;Fecha:&nbsp;{{
                            formP.fecharegistro
                          }}&nbsp;&nbsp; </label
                        >&nbsp;
                        <label class="border"
                          >&nbsp;Usuario:&nbsp;{{ formP.usuario }}&nbsp; </label
                        >&nbsp;&nbsp;
                        <label
                          class="border"
                          style="color: #ff7f00; font-size: 12px"
                          v-if="usuario == formP.usuario || rol == 1"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;<label
                            v-if="estado == 'ACTIVO'"
                            @click="verHCProcesoUser(formP)"
                            ><i
                              class="fas fa-pencil-alt"
                              title="Editar valoración"
                            ></i></label
                          >&nbsp;&nbsp;
                          <!--&nbsp;&nbsp;&nbsp;&nbsp;<i class="far fa-save" title="Guardar valoración"></i>&nbsp;&nbsp;&nbsp;&nbsp;-->
                          <!--&nbsp;&nbsp;<i class="fas fa-door-closed" title="Finalizar valoración"></i>&nbsp;&nbsp;&nbsp;&nbsp;-->
                          <!--&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-trash" aria-hidden="true" title="Eliminar valoración"></i>&nbsp;&nbsp;&nbsp;&nbsp;-->
                        </label>
                      </div>
                    </div>
                    <div class="col-md-12 text-start">
                      <label class="fw-bold">Valoración: </label>

                      <textarea
                        class="textareaVal"
                        v-model="formP.valoracion"
                        placeholder="Valoración por sesión."
                        :disabled="disabledValoracion"
                      ></textarea>
                    </div>

                    <div class="col-md-12 text-start">
                      <label class="fw-bold">Tratamiento: </label>
                      <textarea
                        class="textareaTra"
                        v-model="formP.tratamiento"
                        placeholder="Tratamiento por sesión."
                        :disabled="disabledValoracion"
                      >
                      </textarea>
                      <label class="text-start" style="color: #000000"
                        >Se aplicó lo siguiente:&nbsp;{{
                          formP.tratamientoselect
                        }}
                      </label>
                    </div>
                    <div class="col-md-12 text-start">
                      <label class="fw-bold">Recomendaciones: </label>
                      <textarea
                        class="textarea"
                        v-model="formP.recomendaciones"
                        placeholder="Tratamiento por sesión."
                        :disabled="disabledValoracion"
                      ></textarea>
                    </div>
                    <div class="col-md-4"></div>
                    <!--
                        <div style="height: 10px">
                          <hr />
                        </div>
                        -->
                  </div>
                </div>
              </template>
              <!--Nueva valoración-->
              <template v-if="estadoValoracion == 2">
                <div class="form-control-sm row">
                  <div class="col-md-2 text-end">
                    <label class="">{{ codigohcproceso }} </label>
                  </div>
                  <div class="col-md-2 text-end">
                    <label class="">Fecha de Sesión: </label>
                  </div>
                  <div class="col-md-2">
                    <input
                      type="date"
                      class="form-control form-control-sm inputText"
                      v-model="fecharegistro"
                      max="2100-12-31T23:59"
                    />
                  </div>
                </div>
                <div class="form-control-sm row">
                  <div class="col-md-6 text-end">
                    <label class="">Valoración: </label>

                    <textarea
                      class="textarea"
                      v-model="valoracion"
                      placeholder="Valoración por sesión."
                    ></textarea>
                  </div>

                  <div class="col-md-6 text-end">
                    <label class="">Tratamiento: </label>
                    <textarea
                      class="textarea"
                      v-model="tratamiento"
                      placeholder="Tratamiento por sesión."
                    ></textarea>
                  </div>
                  <div class="col-md-6 text-end">
                    <label class="">Se aplico al tratamiento: </label>
                    <select
                      class="form-select form-control-sm"
                      v-model="tratamientosSelect"
                      multiple
                      @change="seleccionarTratamientos()"
                      style="font-size: 12px; height: 150px"
                    >
                      <option
                        v-for="variable in arrayTratamientos"
                        :key="variable.id"
                        :value="variable.nombre"
                        v-text="variable.nombre"
                      ></option>
                    </select>
                  </div>
                  <div class="col-md-6 text-start">
                    <label>Tratamientos aplicados en la sesión: </label>
                    <div class="border">
                      <label
                        v-for="(variable, index) in arrayTratamientosAll"
                        :key="index"
                        class="border"
                        style="font-size: 12px; border-radius: 4px"
                        >&nbsp;{{ variable }}&nbsp;
                        <sup
                          class="border"
                          style="color: red; border-radius: 4px"
                          @click="elminarSelectTratamientos(variable)"
                          ><i class="fa fa-times" aria-hidden="true"></i
                        ></sup>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-12 text-end">
                    <label class=""
                      >Recomendaciones/Actividades en casa:
                    </label>

                    <textarea
                      class="textarea"
                      v-model="recomendaciones"
                      placeholder="Recomendaciones por sesión."
                    ></textarea>
                  </div>
                  <div class="col-md-4"></div>
                </div>
                <hr style="height: 1px" />
                <template v-if="rol == '4'">
                  <div class="form-control-sm row">
                    <div class="col-md-3 text-center">
                      <label class="">Registro de receta&nbsp;&nbsp;</label>
                    </div>
                    <div class="col-md-5 text-end">
                      <label class="">Número de receta:&nbsp;&nbsp;</label>
                    </div>
                    <div class="col-md-2 text-start">
                      <input
                        type="text"
                        class="form-control form-control-sm inputText"
                        placeholder="# receta"
                        v-model="numeroreceta"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-control-sm row">
                    <div class="col-md-5 text-end">
                      <label class="">Medicamento:&nbsp;&nbsp;</label>
                      <textarea
                        class="textareareceta"
                        v-model="medicamento"
                        placeholder="Medicameto a suministrar."
                      ></textarea>
                    </div>
                    <div class="col-md-6 text-end">
                      <label class="">Indicaciones:&nbsp;&nbsp;</label>
                      <textarea
                        class="textareareceta"
                        v-model="instrucciones"
                        placeholder="Instrucciones del medicamento."
                      ></textarea>
                    </div>
                    <div class="col-md-1 text-end">
                      <label>Agregar</label>
                      <button
                        @click="agregarDetalleReceta()"
                        class="btn btn-outline-primary btn-sq-xs"
                      >
                        <i class="fa fa-plus-circle" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <div class="form-control-sm row">
                    <!--
                    <label class="text-start"
                      >Número de receta:&nbsp;{{ numeroreceta }}</label
                    >
                    -->
                    <div class="col-md-8 text-start">
                      <table class="table table-bordered table-sm" width="70%">
                        <thead>
                          <tr>
                            <th>&nbsp;&nbsp;Eliminar</th>
                            <th>Medicamento</th>
                            <th>Instrucciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(rect, index) in arrayRecetaDetalles"
                            :key="index"
                          >
                            <td>
                              <label @click="eliminarDetalleReceta(index)"
                                >&nbsp;&nbsp;<i
                                  class="fa fa-times-circle"
                                  aria-hidden="true"
                                ></i
                              ></label>
                            </td>
                            <td v-text="rect.medicamento"></td>
                            <td v-text="rect.instrucciones"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>
              </template>
            </div>
            <!--SIGNOS VITALES-->
            <div class="card-body border" v-if="seccionesPagina == 5">
              <div class="form-control-sm row">
                <div class="col-md-3 text-end">
                  <label class="">Frecuencia Cardíaca: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Frecuencia Cardíaca"
                    v-model="frecuenciacardica"
                    title="Frecuencia Cardíaca"
                  />
                </div>
                <div class="col-md-3 text-end">
                  <label class="">Frecuencia Respiratoria: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Frecuencia Respiratoria"
                    v-model="frecuenciarespiratoria"
                    title="Frecuencia Respiratoria"
                  />
                </div>
                <div class="col-md-3 text-end">
                  <label class="">T.Art.SYS: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Tensión arterial sistólica"
                    v-model="tensionarterialsist"
                    title="Tensión Arterial"
                  />
                </div>
                <div class="col-md-1 text-end">
                  <label class=""> / </label>
                </div>
                <div class="col-md-2 text-end">
                  <label class="">T.Art.DIA: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Tensión arterial diastólica"
                    v-model="tensionarterialdiast"
                    title="Tensión Arterial"
                  />
                </div>
                <div class="col-md-2 text-end">
                  <label class=""> </label>
                </div>

                <div class="col-md-3 text-end">
                  <label class="">Saturación Oxígeno: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Saturación Oxígeno"
                    v-model="saturacionoxigeno"
                    title="Saturación Oxígeno"
                  />
                </div>

                <div class="col-md-3 text-end">
                  <label class="">Temperatura: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Temperatura"
                    v-model="temperatura"
                    title="Temperatura"
                  />
                </div>

                <div class="col-md-3 text-end">
                  <label class="">Peso(Kg): </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Peso"
                    v-model="peso"
                    title="Peso"
                    @blur="calcularIMC()"
                  />
                </div>

                <div class="col-md-3 text-end">
                  <label class="">Estatura(m): </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Estatura"
                    v-model="estatura"
                    title="Estatura"
                    @blur="calcularIMC()"
                  />
                </div>
                <div class="col-md-3 text-end">
                  <label class="">IMC: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="IMC"
                    v-model="imc"
                    title="IMC"
                    readonly
                  />
                </div>
                <div class="col-md-3 text-end">
                  <label class="">Glucemia: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="number"
                    class="form-control form-control-sm inputText"
                    placeholder="Glucemia"
                    v-model="glucemia"
                    title="Glucemia"
                  />
                </div>
                <div class="col-md-3 text-end">
                  <label class="">Edad: </label>
                </div>
                <div class="col-md-2">
                  <input
                    type="text"
                    class="form-control form-control-sm inputText"
                    placeholder="Edad"
                    v-model="edad"
                    required
                  />
                </div>
              </div>

              <div class="form-control-sm row">
                <div class="col-md-8"></div>
                <div class="col-md-2">
                  <!--
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
                      data-bs-dismiss="modal"
                      @click="cerrarModalSignosVitales()"
                    >
                      <i class="fas fa-window-close"></i>&nbsp;Cerrar
                    </button>
                    -->
                </div>
                <div class="col-md-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm inpuText"
                    @click="salirSignosVitales(1)"
                  >
                    <i class="far fa-save"></i>&nbsp;Regresar<!--condicion -->
                  </button>
                </div>
                <div class="col-md-5">&nbsp;</div>
              </div>
            </div>
            <!--LISTAR RECETAS POR USUARIO Y CASO DE TRATAMIENTO-->
            <div class="card-body border" v-if="seccionesPagina == 6">
              <div class="table-responsive">
                <table class="table table-bordered table-sm" width="100%">
                  <thead>
                    <tr>
                      <th>Acciones</th>
                      <th>Caso</th>
                      <th>Sesión</th>
                      <th>Numero receta</th>
                      <th>Fecha</th>
                      <th>Estado</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(formR, index) in arrayRecetaHC" :key="index">
                      <td>
                        <div
                          class="dropdown"
                          style="background: #ffffff; color: #ffffff"
                        >
                          <button
                            class="btn btn-secondary dropdown-toggle"
                            type="button"
                            id="dropdownMenu2"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style="
                              background: #336699;
                              color: #ffffff;
                              font-size: 12px;
                            "
                          >
                            Acciones
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenu2"
                            style="font-size: 13px"
                          >
                            <li
                              v-if="usuario == formR.usuario || rol == 1"
                              @click="activarReceta(formR)"
                            >
                              <button class="dropdown-item" type="button">
                                <i class="fas fa-pencil-alt"></i>&nbsp;Activar
                              </button>
                            </li>
                            <li
                              v-if="formR.estado == 'ACTIVO'"
                              @click="inactivarReceta(formR)"
                            >
                              <button class="dropdown-item" type="button">
                                <i class="fa fa-bars" aria-hidden="true"></i
                                >&nbsp;Anular
                              </button>
                            </li>

                            <li
                              v-if="
                                (rol == 2 || rol == 1 || rol == 4) &&
                                formR.estado == 'ACTIVO'
                              "
                            >
                              <button
                                class="dropdown-item"
                                type="button"
                                @click="generarPDFReceta(formR, 1)"
                              >
                                <i class="fa fa-download"></i>&nbsp;Descargar
                              </button>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td v-text="codigohc"></td>
                      <td v-text="formR.procesohcId" class="text-start"></td>
                      <td v-text="formR.numero" class="text-start"></td>
                      <td v-text="formR.fecha" class="text-start"></td>
                      <td v-text="formR.estado"></td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>

            <div class="card-body border">
              <div class="form-control-sm row" v-if="seccionesPagina == 2">
                <div class="col-md-2 text-end border">
                  Archivos adjuntos&nbsp;&nbsp;<br /><label
                    class="text-reader"
                    style="font-size: 10px"
                  >
                    <i class="fa fa-cloud"></i>
                    <input
                      type="file"
                      style="display: none"
                      @change="uploadFile"
                    /> </label
                  >&nbsp;&nbsp;&nbsp;
                  <label style="font-size: 10px; color: #b81313"
                    >Hasta&nbsp;5MB</label
                  >
                </div>
                <div class="col-md-10 text-start border">
                  <ul style="text-align: left">
                    <li
                      v-for="(archivo, index) in listaFiles"
                      :key="index"
                      style="list-style: none; list-style-position: inside"
                    >
                      <label style="font-size: 11px">{{ archivo }}</label
                      >&nbsp;|&nbsp;
                      <label @click="descargarFile(archivo)"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                        ></i></label
                      >&nbsp;&nbsp;
                      <label
                        v-if="usuario == usuarioGral"
                        @click="eliminarFile(archivo)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i></label
                      >&nbsp;&nbsp;
                    </li>
                  </ul>
                </div>
              </div>

              <div
                class="form-control-sm row"
                v-if="seccionesPagina == 2"
                style="height: 1px"
              >
                <div class="col-md-10 text-end"></div>
                <div class="col-md-2 text-end" v-if="codigohc == 0">
                  <!--<div class="col-md-2 text-end" >-->
                  <label
                    class="btn btn-outline-primary btn-sm inpuText"
                    @click="registrarHC()"
                  >
                    <i class="far fa-save"></i>&nbsp;Guardar HC..
                  </label>
                </div>

                <div
                  class="col-md-2 text-end"
                  v-if="
                    (codigohc != 0 && usuario == usuarioGral) ||
                    (codigohc != 0 && rol == 1)
                  "
                >
                  <!--<div class="col-md-2 text-end" >-->
                  <label
                    class="btn btn-outline-primary btn-sm inpuText"
                    @click="registrarHC()"
                  >
                    <i class="far fa-save"></i>&nbsp;Actualizar HC.
                  </label>
                </div>
              </div>
              <div
                class="form-control-sm row"
                v-if="seccionesPagina == 4 && estadoValoracion == 2"
                style="height: 1px"
              >
                <div class="col-md-10 text-end"></div>
                <div class="col-md-2 text-end">
                  <label
                    class="btn btn-outline-primary btn-sm inpuText"
                    @click="registrarHCProceso()"
                  >
                    <i class="far fa-save"></i>&nbsp;Guardar HCP
                  </label>
                </div>
              </div>
            </div>

            <div class="card-footer text-muted justify-content-md-end">
              <div class="form-control-sm row" style="height: 1px">
                <div class="col-md-1 text-center" style="font-size: 12px">
                  Pag:&nbsp;{{ seccionesPagina }}
                </div>
              </div>
            </div>

            <!-- fin
              </div>
            </div>
            -->
          </div>
        </div>
      </template>
      <!-- Fin página uno -->
    </div>
  </div>

  <!-- incio de modal productos Condiciones Benef-->
  <div
    class="modal fade"
    tabindex="-1"
    :class="{ mostrar: modalSignosVitles }"
    role="dialog"
    aria-labelledby="staticBackdropLabel"
    style="
      display: none;
      overflow-y: scroll;
      max-height: 100%;
      margin-top: 9px;
      margin-bottom: 20px;
    "
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
      style="max-width: 95%; margin-top: 28px; margin-right: 80px"
    >
      <br />
      <div class="modal-content" style="background-color: #ecf0f3">
        <div class="modal-header" style="height: 10px; font-size: 13px">
          <label v-text="tituloModal"></label>
          <button
            type="button"
            class="btn-close btn-sm"
            @click="cerrarModalSignosVitales()"
          ></button>
        </div>

        <div class="card-body">
          <div class="form-group row">
            <div class="container">
              <div class="card">
                <div class="card-body border">
                  <!--<template v-if="opcionCondicionP == 1">-->
                  <div class="card">
                    <div class="form-control-sm row">
                      <div class="col-md-3 text-end">
                        <label class="">Operador: </label>
                      </div>
                      <div class="col-md-4">
                        <select
                          class="form-select form-select-sm form-control is-valid inpuText"
                          v-model="operadorCondiciones"
                          required
                          @change="selectOperador()"
                        >
                          <option value="0" disabled>Seleccione</option>
                          <option value="OR">Para los productos</option>
                          <option value="AND">
                            Y necesita de los productos
                          </option>
                        </select>
                      </div>
                      <div style="height: 12px">
                        <hr />
                      </div>
                    </div>
                  </div>
                  <!--</template>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
        <div class="modal-body" style="background-color: #f7f7f7">
        </div>
      -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            data-bs-dismiss="modal"
            @click="cerrarModalSignosVitales()"
          >
            <i class="fas fa-window-close"></i>&nbsp;Cerrar
          </button>
          <button
            v-if="
              opcionCondicionP == 1 &&
              estadoNewEdit == 1 &&
              cantidadCondicion > 0 &&
              listaCodigos.length > 0
            "
            type="button"
            class="btn btn-outline-primary btn-sm inpuText"
            @click="asignarHijo(1)"
          >
            <i class="far fa-save"></i>&nbsp;Asignar<!--condicion -->
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- fin de modal productos Condiciones Benef-->
  <!-- incio de modal opciones formulario-->
  <div
    class="modal fade"
    tabindex="-1"
    :class="{ mostrar: modalOpcionesF }"
    role="dialog"
    aria-labelledby="staticBackdropLabel"
    style="
      display: none;
      overflow-y: scroll;
      max-height: 100%;
      margin-top: 9px;
      margin-bottom: 20px;
    "
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
      style="max-width: 65%; margin-top: 28px; margin-right: 80px"
    >
      <br />
      <div class="modal-content" style="background-color: #ecf0f3">
        <div class="modal-header">
          <h6
            class="modal-title"
            id="staticBackdropLabel"
            v-text="tituloModal"
          ></h6>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            @click="cerrarModalOpcionesF()"
            aria-label="Close"
          ></button>
        </div>

        <div class="card-body">
          <div class="form-group row">
            <div class="container">
              <div class="card">
                <div class="card-body border">
                  <template v-if="opcionesFormulario == 1">
                    <div class="card">
                      <div class="card-body">
                        <div class="form-control-sm row">
                          <div class="col-md-5 text-end">
                            <label class=""
                              >Cancelar formulario de negociación:&nbsp;
                              {{ codigoFormulario }}</label
                            >
                          </div>
                          <div class="col-md-4">
                            {{ nombre }}
                          </div>
                          <div style="height: 12px">
                            <hr />
                          </div>
                        </div>

                        <div class="form-control-sm row">
                          <div class="col-md-2 text-end">
                            <label class="">Razones:&nbsp;</label>
                          </div>
                          <div class="col-md-6">
                            <textarea
                              class="form-control form-control-sm is-valid"
                              id="exampleFormControlInput1"
                              placeholder="A razón de que se cancela"
                              v-model="razones"
                              rows="4"
                              cols="80"
                            >
                            </textarea>
                          </div>

                          <div class="col-md-1"></div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
        <div class="modal-body" style="background-color: #f7f7f7">
        </div>
      -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            data-bs-dismiss="modal"
            @click="cerrarModalOpcionesF()"
          >
            <i class="fas fa-window-close"></i>&nbsp;Cerrar
          </button>
          <button
            v-if="opcionesFormulario == 1 && razones.length > 0"
            type="button"
            class="btn btn-warning btn-sm"
            @click="cancelarFormulario()"
          >
            <i class="far fa-save"></i>&nbsp;Cancelar<!--condicion -->
          </button>
          <button
            v-if="opcionCondicionP == 2 && estadoNewEdit == 1"
            type="button"
            class="btn btn-warning btn-sm"
            @click="asignarPadreBeneficios(1)"
          >
            <i class="far fa-save"></i>&nbsp;Asignar<!--beneficios -->
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- fin de modal opciones formulario-->
  <!-- incio de modal ver codigos condiciones formulario-->
  <div
    class="modal fade"
    tabindex="-1"
    :class="{ mostrar: modalVerCodigos }"
    role="dialog"
    aria-labelledby="staticBackdropLabel"
    style="
      display: none;
      overflow-y: scroll;
      max-height: 100%;
      margin-top: 128px;
      margin-bottom: 20px;
    "
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
      style="max-width: 50%; margin-top: 28px; margin-right: 200px"
    >
      <br />
      <div class="modal-content" style="background-color: #ecf0f3">
        <div class="modal-header" style="height: 30px">
          <h8
            class="modal-title inputText"
            id="staticBackdropLabel"
            v-text="condicionText"
          ></h8>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            @click="cerrarModalVerCodigos()"
            aria-label="Close"
          ></button>
          <!--
          <i class="fas fa-window-close" @click="cerrarModalVerCodigos()"></i>&nbsp;Cerrar
        --></div>

        <div class="card-body" style="background-color: #ffffff">
          <!--
                        <div class="form-control-sm row">
                          <div class="col-md-5 text-end">
                            <h4 class=""
                              >{{ condicionText}}</h4
                            >
                          </div>
                          
                          <div style="height: 12px">
                            <hr />
                          </div>
                        </div>
                        -->

          <div class="form-control-sm row">
            <!--
                            <div class="col-md-2 text-end">
                            <label class="">Codigos:&nbsp;</label>
                          </div>
                          -->
            <div class="col-md-12">
              <textarea
                class="form-control form-control-sm is-valid inputText"
                id="exampleFormControlInput1"
                placeholder="A razón de que se cancela"
                v-model="codigosCondicionesVer"
                rows="4"
                cols="80"
              >
              </textarea>
            </div>

            <div class="col-md-1"></div>
          </div>
        </div>
        <!--
        <div class="modal-body" style="background-color: #f7f7f7">
        </div>
      -->
        <!--
        <div class="modal-footer" style="height:30px;">
            <i class="fas fa-window-close" @click="cerrarModalVerCodigos()"></i>&nbsp;Cerrar
        </div>
      --></div>
    </div>
  </div>
  <!-- fin de modal ver codigos condiciones formulario-->
</template>
<script>
import "@/assets/styleRC.css";
import axios from "axios";
import IPServie from "../service/ConectionDataService";
import TextReaderP from "../service/TextReaderProducto";
import TextReaderC from "../service/TextReaderCiudad";
import TextReaderO from "../service/TextReaderOficina";
import TextReaderPr from "../service/TextReaderProvincia";
//import TextReaderR from "../service/TextReaderRegion";
//import TextReaderS from "../service/TextReaderSucursal";
import TextReaderSc from "../service/TextReaderSegmento";

import FechaService from "../service/FechaService";

import * as XLSX from "xlsx";

export default {
  name: "App",
  data() {
    return {
      //filter
      filtrarLike: "Nombre",
      selectFilterLike: "Nombre",
      selectPCB: 0,
      selectCond: 1,
      selectBenef: 1,
      buscarlike: "",
      buscarEstado: "Estado",
      buscarModalidad: "0",
      //array
      arrayFechasprocesos: [],
      //arrays
      arrayPromocionesAll: [],
      arrayPromocionesAll_all: [],
      arrayPromocionesAll_pag: [],
      arrayPromocionesAll_ES: [], // estado
      arrayPromocionesAll_MD: [], //  modalidad
      //
      paginasTotal: 10,
      obj_per_page: 50,
      paginaActiva: 1,
      controlPaginas: 0,

      http_: "",
      ///PACIENTE
      tipodocumento: "",
      numdocumento: "",
      codigoPaciente: 0,
      estado: "ACTIVO",
      fecharegistro: "",
      apellidos: "",
      nombres: "",
      apellidosnombres: "",
      edad: "",
      fechanacimiento: "",
      tiposangre: "",
      genero: "0",
      estadocivil: "0",
      telefono: "",
      celular: "",
      operadora: "0",
      telefonoemergencia: "",
      correo: "",
      nacionalidad: "0",
      ciudad: "",
      direccion: "",
      referenciaubicacion: "",
      religion: "",
      ocupacion: "",

      ///

      /////////HC
      codigohc: "0",
      estado: "ACTIVO",
      fechaingreso: "",
      peso: 0,
      talla: 0,
      estatura: 0,
      imc: 0,
      medicoremitente: "",
      antecedentestratamiento: "",
      antecedentespatologicos: "",
      checkantecedentes: [],
      tratamientosprevios: "",
      seguromedico: "NO",
      numeroseguro: "",
      aseguradora: "",
      arrayHCPacienteAll: [],
      nombreproceso: "",

      embarazo: "NO",
      numhijos: 0,
      diagnosticocie: "",
      fechainiciosintomas: "",
      causageneral: "",
      responsableHC: "",

      //signos vitales
      estadoSignosVitales: 0,
      estadoValoracion: 0,
      disabledValoracion: true,
      modalSignosVitles: 0,
      frecuenciacardica: 0,
      tensionarterialsist: 0,
      tensionarterialdiast: 0,
      frecuenciarespiratoria: 0,
      saturacionoxigeno: 0,
      glucemia: 0,
      temperatura: 0,
      // ProcesoHC
      arrayHCPProcesoAll: [],
      valoracion: "",
      tratamiento: "",
      recomendaciones: "",
      //para ver caso general
      valoracionGral: "",
      antecedentestratamientoGral: "",
      tratamientospreviosGral: "",
      fecharegistroGral: "",
      usuarioGral: "",

      //Parametros
      arrayTratamientos: [],
      arrayTratamientosAll: [],
      tratamientosSelect: [],

      seccionesPagina: 0,
      usuario: "",
      usuarioultimomodifica: "",
      fecharultimocambio: "",
      rol: 0,
      rolDesc: "",
      usuarioModifica: "",
      codigoFormulario: "0",
      //Receta
      medicamento: "",
      instrucciones: "",
      arrayReceta: [],
      arrayRecetaHC: [],
      arrayRecetaDetalles: [],
      numeroreceta: 0,

      spinnerControl: 0,
      verpagina: 0,
      //

      negociacionText: "",
      fechaContrato: "",
      fechaInicioSistema: "",
      fechaNegociacion: "",
      fechaInicio: "",
      fechaFin: "",
      fechaInicioAcumulacion: "",
      disabledFecha: true,
      tipoModalidad: "0",
      tipoAcumulacion: "0",
      periodoCanje: 0,
      mesPendienteCanje: 0,
      mecanicaDescripcion: "",
      borrarHistorial: false,
      gerenteCodigoLinea: "",
      gerenteLinea: "",
      cargoLinea: "",
      correoLinea: "",
      idNegoExt: "",
      negociadorExt: "",
      correoNegExt: "",
      proveedor: "",
      laboratorioPrv: "0",
      arrayLaboratorioPrv: [],
      comprador: "0",
      arrayComprador: [],
      responsable: "",
      lineaNegocio: "0",
      generaCobro: "SI",
      asumeCategoria: "NO",
      paginaFormulario: 1,
      observacionesLocal: "",
      observacionesCondicion: "",
      observacionesBeneficio: "",
      observacionesGenerales: "",
      ///
      arrayGerente: [],
      arrayNegociador: [],
      listaNegociadores: [],

      ///

      arrayAsumeCategoria: [],
      arrayGeneraCobro: [],
      arrayResponable: [],
      arrayLineaComercial: [],
      arrayProveedores: [],
      arrayFormularioAll: [],
      arrayFormularioFilter: [],
      //Localizacion
      modalLocalizacion: 0,
      opcionLocalizacion: 0,
      tituloModal: "",
      checkSucursales: [],
      operadorCondiciones: "0",
      condicionAcumulacion: true,
      condicionCanje: true,
      sucursalesExt: "",
      disabledLoc: true,
      checkActivarLoc: false,
      checkRegion: [],
      //
      grupoCondiciones: [],
      arrayGrupoCondiciones: [],
      arrayCondicionesDet: [],
      codigoGrupo: 0,
      nombreGrupo: "",
      operador: "OR",
      condiciones: [],
      tipoCondicionOY: "",
      mensajeCondicion: "",
      idPadre: 0,
      idHijo: 0,
      indicePadre: 0,
      condicionExisteSucursal: 0,
      validarGrupoCondiciones: 0,

      //
      checkTodasProvincias: true,
      palabraClaveLike: 0,
      listaCodigos: [],
      buscarPalabraLike: "",
      mostrarComboLike: false,
      mostrarComboLikeN: false,
      mostrarComboLikeG: false,
      estadoNewEdit: 0,

      //Condición productos
      opcionCondicionP: 0,
      modalCondicionesP: 0,
      relacionAcumulacionCond: 0,
      acumulaCajasCondicion: false,
      esAcumulableCondicion: true,
      cantidadCondicion: 0,

      arrayBeneficios: [],
      arrayItemBenef: [],
      cantidadBenef: 0,
      limiteAplicacion: 0,
      limiteCanje: 0,
      pagadoresDeuda: [],

      listaFiles: [],
      //opciones formu
      modalOpcionesF: 0,
      opcionesFormulario: 0, //1: cancelar
      razones: "",

      //ver condicones
      condicionText: "",
      codigosCondicionesVer: "",
      modalVerCodigos: 0,
      //
      arraryBuscarLike: [],
      //popup
      negociacionTextTitle: "",
      fechaNegociacionTitle: "",
      fechaInicioTitle: "",
      tipoAcumulacionTitle: "",
      periodoCanjeTitle: "",
      mesPendienteCanjeTitle: "En caso de emergencia llamar",
      mecanicaDescripcionTitle: "",
      fechaInicioAcumulacionTitle: "",
      responsableTitle: "",

      // validacion
      errorFormularioLgth: 0,
      errorMostrarMsjForm: [],
      //pagador deudas
      modalCobros: 0,
      condicion_cobros: 0,
      arrayCobros: [],
      metodoAplicacion: "Porcentaje",
      listaCobro: "ppp",
      tipoPagador: "Farmaenlace",
      valorCobro: 0,
      porcentajeCobro: 0,
      totalPorCobro: 0,
      //
      empresa_RUC: "",
      empresa_NC: "",
      //carga de excel
      arrayFileXLS: [],
    };
  },
  methods: {
    handleFileUpload(event) {
      let arrayFileXLSTemp = [];
      let listCodigosTemp = "";
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const fileData = reader.result;
        const workbook = XLSX.read(fileData, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        //this.arrayFileXLS.push(sheetData);
        arrayFileXLSTemp.push(sheetData);
        //console.log(sheetData);
        arrayFileXLSTemp = sheetData;
        console.log(sheetData);
        for (let i = 0; i < sheetData.length; i++) {
          listCodigosTemp = listCodigosTemp + sheetData[i].CODIGO + ",";
        }
        console.log(listCodigosTemp);
        this.listaCodigos = listCodigosTemp.substring(
          0,
          listCodigosTemp.length - 1
        );
      };

      reader.readAsBinaryString(file);
      /*
      console.log(arrayFileXLSTemp);
      for(let i=0; i<arrayFileXLSTemp.length;i++){
        listCodigosTemp = listCodigosTemp + arrayFileXLSTemp[i].CODIGO;
      }
      console.log(listCodigosTemp);
      */
    },
    salirSignosVitales() {
      let me = this;
      me.seccionesPagina = me.estadoSignosVitales;
    },
    abrirModalSignosVitales(valr) {
      let me = this;
      me.seccionesPagina = 5;
      me.estadoSignosVitales = valr;
    },
    abrirOpcionesValoracion(valr) {
      let me = this;
      me.estadoValoracion = valr;
      if (valr == 1) me.disabledValoracion = true;
      if (valr == 2) {
        me.disabledValoracion = false;
        me.limpiarProcesoHC();
      }
    },
    limpiarProcesoHC() {
      let me = this;
      me.codigohcproceso = 0;

      me.valoracion = "";
      me.tratamiento = "";
      me.recomendaciones = "";
      me.arrayTratamientosAll = [];
      me.arrayRecetaDetalles = [];
      me.fecharegistro = FechaService.fechaHoy().substring(0, 10);
      me.numeroreceta = "0";
      me.agenda;
      if (me.arrayHCPProcesoAll.length > 0) {
        me.peso = 0;
        me.talla = 0;
        me.estatura = 0;
        me.imc = 0;

        me.frecuenciacardica = 0;
        me.tensionarterialsist = 0;
        me.tensionarterialdiast = 0;
        me.frecuenciarespiratoria = 0;
        me.saturacionoxigeno = 0;
        me.glucemia = 0;
        me.temperatura = 0;
      }
    },
    abrirModalFormulario(form, accion) {
      let me = this;
      me.modalOpcionesF = 1;
      me.tituloModal = "Cancelar formulario";
      me.opcionesFormulario = accion;
      me.codigoFormulario = form.codigoFormulario;
      me.nombre = form.nombre;
    },
    abrirModalVerCodigos(condic, codigosList) {
      let me = this;
      me.modalVerCodigos = 1;
      me.condicionText = condic;
      me.codigosCondicionesVer = codigosList;
    },
    cerrarModalSignosVitales() {
      let me = this;
      me.modalSignosVitles = 0;
    },
    cerrarModalLocal() {
      let me = this;
      me.modalLocalizacion = 0;
      me.tituloModal = "";
      me.buscarPalabraLike = "";
      me.mostrarComboLike = false;
      me.listaCodigos = "";
    },
    cerrarModalOpcionesF() {
      let me = this;
      me.modalOpcionesF = 0;
      me.opcionesFormulario = 0;
      me.tituloModal = "";
      me.razones = "";
    },
    cerrarModalVerCodigos() {
      let me = this;
      me.modalVerCodigos = 0;
    },
    cerrarModalCobros() {
      this.modalCobros = 0;
    },

    menuCabecera(valor) {
      let me = this;
      if (valor == 1) {
        me.verpagina = 0;
        me.listarHC();
      }
      if (valor == 2) {
        me.limpiarFormulario();
        me.verpagina = 1;
        me.seccionesPagina = 1;
      }
    },
    cargarSeccion(valSeccion) {
      let me = this;
      me.seccionesPagina = valSeccion;
      if (valSeccion == 3 && me.codigohc != "0") {
        me.listarHCPaciente();
      }
      if (valSeccion == 2) {
        me.codigohc = 0;
        me.limpiarHC();
      }
      if (valSeccion == 5) {
        me.seccionesPagina = 6;
        me.listarReceta();
      }
    },
    limpiarHC() {
      let me = this;
      //console.log(FechaService.fechaHoy());
      me.medicoremitente = "";
      me.antecedentestratamiento = "";
      me.antecedentespatologicos = "";
      me.tratamientosprevios = "";
      me.valoracion = "";
      me.checkantecedentes = [];
      me.seguromedico = "NO";
      me.numeroseguro = "";
      me.aseguradora = "";
      me.diagnosticocie = "";
      me.fechainiciosintomas = "";
      me.causageneral = "";
      me.estado = "";
      me.fecharegistro = FechaService.fechaHoy();

      me.peso = 0;
      me.talla = 0;
      me.estatura = 0;
      me.imc = 0;

      me.frecuenciacardica = 0;
      me.tensionarterialsist = 0;
      me.tensionarterialdiast = 0;
      me.frecuenciarespiratoria = 0;
      me.saturacionoxigeno = 0;
      me.glucemia = 0;
      me.temperatura = 0;

      me.embarazo = "";
      me.numhijos = "";
      me.nombreproceso = "";
      me.arrayHCPProcesoAll = [];

      if (me.rol == 4) {
        me.recetaNumero();
      }
    },

    listarHCPaciente() {
      let me = this;
      var url = me.http_ + "/APIHC/hc/findHCDocument/" + me.numdocumento;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arrayHCPacienteAll = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiarFormulario() {
      let me = this;
      me.verpagina = 1;
      me.codigoPaciente = 0;
      me.tipodocumento = "0";
      me.numdocumento = "";
      me.fechaInicioSistema = FechaService.fechaHoy();
      me.fecharegistro = FechaService.fechaHoy();
      me.apellidos = "";
      me.nombres = "";
      me.edad = "";
      me.fechanacimiento = "";
      me.tiposangre = "";
      me.genero = "0";
      me.estadocivil = "0";
      me.telefono = "";
      me.celular = "";
      me.operadora = "0";
      me.telefonoemergencia = "";
      me.correo = "";
      me.nacionalidad = "";
      me.ciudad = "";
      me.direccion = "";
      me.referenciaubicacion = "";
      me.religion = "0";
      me.ocupacion = "";

      me.cargaParametros();
    },
    cargaParametros() {
      let me = this;
      me.listarHC();
      me.cargarTratamientos();
      /*
      me.listarGeneraCobro();
      me.listaTitlePopUp();
      me.listarAsumeCategoria();
      me.listarResponsable();
      me.listarLineaComercial();
      me.listarProveedores();
      
      me.listarNegociador();
      me.verEmpresa();
      */
      if (me.rol == 1) me.rolDesc = "Administrador";
      if (me.rol == 2) me.rolDesc = "Gestión";
      if (me.rol == 3) me.rolDesc = "Fisioterapista";
      if (me.rol == 4) me.rolDesc = "Médico";
    },
    cargarTratamientos() {
      let me = this;
      var url = me.http_ + "/APIHC/parametros/all";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arrayTratamientos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    seleccionarTratamientos() {
      let me = this;
      me.arrayTratamientosAll.push(me.tratamientosSelect.toString());
    },
    elminarSelectTratamientos(valStr) {
      let me = this;
      var newArray = me.arrayTratamientosAll.filter((item) => item !== valStr);
      console.log(newArray);
      me.arrayTratamientosAll = newArray;
    },
    recetaNumero() {
      let me = this;
      var url = me.http_ + "/APIHC/hc/maxNumReceta/" + me.usuario;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.numeroreceta = response.data;
          me.numeroreceta = me.numeroreceta + 1;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    verEmpresa() {
      let me = this;
      var url = me.http_ + "/acumulacion/mf/empresa/allActive";
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.empresa_RUC = response.data.ruc;
          me.empresa_NC = response.data.nombre_razon;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    validarFormulario() {
      let me = this;
      me.errorFormularioLgth = 0;
      me.errorMostrarMsjForm = [];
      if (me.fechaInicio.length < 2) me.fechaInicio = "";
      if (me.fechaInicio.length < 2)
        me.errorMostrarMsjForm.push("Ingresar fecha de incio");
      if (me.fechaFin.length < 2)
        me.errorMostrarMsjForm.push("Ingresar fecha fin");
      if (me.fechaInicioAcumulacion.length < 2)
        me.errorMostrarMsjForm.push("Ingresar fecha de inicio de acumulación");
      if (me.fechaContrato.length < 2)
        me.errorMostrarMsjForm.push("Ingresar fecha de contrato");

      if (!me.negociacionText)
        me.errorMostrarMsjForm.push("Ingrese nombre del formulario");
      if (me.tipoModalidad == 0)
        me.errorMostrarMsjForm.push("Seleccione modalidad");
      if (me.tipoAcumulacion == 0)
        me.errorMostrarMsjForm.push("Seleccione tipo de acumulación");
      if (me.periodoCanje == 0)
        me.errorMostrarMsjForm.push("Ingresar período canje ");
      if (!me.mecanicaDescripcion)
        me.errorMostrarMsjForm.push("Ingrese descripción de mecánica");
      if (!me.gerenteLinea) me.errorMostrarMsjForm.push("Ingrese gerente");
      if (!me.negociadorExt)
        me.errorMostrarMsjForm.push("Ingrese negociador externo");
      if (!me.correoNegExt)
        me.errorMostrarMsjForm.push("Ingrese correo de negociador externo");
      if (!me.proveedor) me.errorMostrarMsjForm.push("Ingrese proveedor");
      if (me.laboratorioPrv == 0)
        me.errorMostrarMsjForm.push("Seleccione laboratorio");
      if (me.comprador == 0)
        me.errorMostrarMsjForm.push("Seleccione comprador");
      if (me.responsable.length < 2)
        me.errorMostrarMsjForm.push("Seleccione responsable");
      if (me.lineaNegocio.length < 2)
        me.errorMostrarMsjForm.push("Seleccione línea comercial");

      if (me.errorMostrarMsjForm.length) {
        me.errorFormularioLgth = 1;
        me.$swal({
          title: "Completar los campos",
          text: me.errorMostrarMsjForm,
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
      }
      return me.errorFormularioLgth;
    },
    registrarHC() {
      let me = this;
      var url = ""; // me.http_ + "/APIHC/persona/save";

      /*
      if (me.validarFormulario()) {
        return;
      }
      */
      if (me.codigohc == 0) {
        url = me.http_ + "/APIHC/hc/save";
        //me.asignarPadre();
      } else {
        url = me.http_ + "/APIHC/hc/updateHC";
      }
      me.responsableHC = me.responsableHC + " | " + me.usuarioGral;

      me.$swal({
        position: "top-end",
        title: "Está seguro de guardar la HC ?",
        text: "Paciente: " + me.apellidos + " " + me.nombres,
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(url, {
              id: me.codigohc,
              idpersona: me.codigoPaciente,
              numdocumento: me.numdocumento,
              edad: me.edad,
              estado: me.estado,
              apellidos: me.apellidos,
              nombres: me.nombres,
              apellidosnombres: me.apellidos + " " + me.nombres,
              peso: me.peso,
              talla: me.talla,
              estatura: me.estatura,
              imc: me.imc,
              medicoremitente: me.medicoremitente,
              antecedentestratamiento: me.antecedentestratamiento,
              antecedentespatologicos: me.antecedentespatologicos,
              valoracion: me.valoracion,
              tratamientosprevios: me.tratamientosprevios,
              checkantecedentes: me.checkantecedentes.toString(),
              causageneral: me.causageneral,
              seguromedico: me.seguromedico,
              numeroseguro: me.numeroseguro,
              aseguradora: me.aseguradora,
              embarazo: me.embarazo,
              numhijos: me.numhijos,
              nombreproceso: me.nombreproceso,
              fechainiciosintomas: me.fechainiciosintomas,
              diagnosticocie: me.diagnosticocie,
              frecuenciacardica: me.frecuenciacardica,
              tensionarterialsist: me.tensionarterialsist,
              tensionarterialdiast: me.tensionarterialdiast,
              frecuenciarespiratoria: me.frecuenciarespiratoria,
              saturacionoxigeno: me.saturacionoxigeno,
              glucemia: me.glucemia,
              temperatura: me.temperatura,
              numeroreceta: me.numeroreceta,
              fecharegistro: me.fecharegistro,

              usuario: me.usuario,
              responsable: me.responsableHC,
            })
            .then(function (response) {
              var respuesta = response.data;
              console.log(respuesta);
              if (respuesta != "") {
                me.codigohc = respuesta.id;
                me.seccionesPagina = 3;
                me.listarHCPaciente();
                //me.verpagina = 2;
              } else {
                me.$swal({
                  position: "top-end",
                  icon: "warning",
                  title: "HC no resgistrado.",
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              me.$swal({
                position: "top-end",
                icon: "success",
                title: "HC no resgistrado. NO HAY CONECCIÓN.. ",
                showConfirmButton: false,
                timer: 3000,
              });
            });
        }
      });
      me.listaFiles = [];
    },
    editarHC(frm) {
      let me = this;
      console.log(frm);
      me.codigohc = frm.id;

      me.numdocumento = frm.numdocumento;
      /*
      me.estado = frm.estado;
      me.fechaingreso =
        frm.fechaingreso.substring(0, 10) +
        "T" +
        frm.fechaingreso.substring(11, 16);
      

        */
      me.apellidos = frm.apellidos;
      me.nombres = frm.nombres;

      me.fechaInicioSistema = FechaService.fechaHoy();

      //me.paginaFormulario = 1;
      me.verpagina = 1;
      me.seccionesPagina = 3;
      //me.listarFile();
      me.buscarPacienteHC();
    },
    editarHCProceso(frmp, tipoHc) {
      let me = this;
      console.log(frmp);
      me.codigohc = frmp.id;
      //me.arrayHCPProcesoAll = frmp.listaHistorialProceso;
      //me.seccionesPagina=4;
      //me.estadoValoracion = 1;
      me.estado = frmp.estado;
      me.peso = frmp.peso;
      me.talla = frmp.talla;
      me.estatura = frmp.estatura;
      me.imc = frmp.imc;
      me.medicoremitente = frmp.medicoremitente;
      me.antecedentestratamiento = frmp.antecedentestratamiento;
      me.antecedentespatologicos = frmp.antecedentespatologicos;
      me.valoracion = frmp.valoracion;
      me.tratamientosprevios = frmp.tratamientosprevios;
      if (frmp.checkantecedentes != null) {
        me.checkantecedentes = frmp.checkantecedentes.split(",");
      }

      //me.checkantecedentes = [];
      //else
      me.seguromedico = frmp.seguromedico;
      me.numeroseguro = frmp.numeroseguro;
      me.aseguradora = frmp.aseguradora;
      me.diagnosticocie = frmp.diagnosticocie;
      me.fechainiciosintomas = frmp.fechainiciosintomas;
      me.causageneral = frmp.causageneral;

      me.frecuenciacardica = frmp.frecuenciacardica;
      me.tensionarterialsist = frmp.tensionarterialsist;
      me.tensionarterialdiast = frmp.tensionarterialdiast;
      me.frecuenciarespiratoria = frmp.frecuenciarespiratoria;
      me.saturacionoxigeno = frmp.saturacionoxigeno;
      me.glucemia = frmp.glucemia;
      me.temperatura = frmp.temperatura;

      me.embarazo = frmp.embarazo;
      me.numhijos = frmp.numhijos;
      me.nombreproceso = frmp.nombreproceso;
      //me.arrayRecetaDetalles = frmp.listaRecetaDetalles;
      me.numeroreceta = frmp.numeroreceta;
      me.estado = frmp.estado;
      me.fecharegistro = frmp.fecharegistro.substring(0, 10);

      if (tipoHc == 1) {
        me.seccionesPagina = 2;
      }
      if (tipoHc == 2) {
        me.seccionesPagina = 4;
        me.estadoValoracion = 1;
      }

      me.valoracionGral = frmp.valoracion;
      me.antecedentestratamientoGral = frmp.antecedentestratamiento;
      me.tratamientospreviosGral = frmp.tratamientosprevios;
      me.fecharegistroGral = frmp.fecharegistro;
      me.usuarioGral = frmp.usuario;
      me.responsableHC = frmp.responsable;

      me.listarHCProceso();
      me.listarReceta();
      me.listarFile();
    },
    listarHCProceso() {
      let me = this;
      var url = me.http_ + "/APIHC/hc/listHCProceso/" + me.codigohc;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arrayHCPProcesoAll = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarReceta() {
      let me = this;
      var url = me.http_ + "/APIHC/receta/recetasCasos/" + me.codigohc;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arrayRecetaHC = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    finalizarProceso(fhc, val) {
      let me = this;
      if (val == 1) {
        var url = me.http_ + "/APIHC/hc/finalizarHC/" + fhc.id;
      }
      if (val == 2) {
        var url = me.http_ + "/APIHC/hc/cancelarHC/" + fhc.id;
      }

      me.$swal({
        position: "top-end",
        title: "Está seguro de ejecutar el proceso ?",
        text: "Proceso, no se reversa.!",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .get(url)
            .then(function (response) {
              console.log(response);
              //me.arrayHCPProcesoAll = response.data;
              me.listarHCPaciente();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    registrarHCProceso() {
      let me = this;
      var url = ""; // me.http_ + "/APIHC/persona/save";
      if (me.codigohcproceso == 0) url = me.http_ + "/APIHC/hc/savephc";
      else url = me.http_ + "/APIHC/hc/updateProcesoHC";
      me.arrayReceta = [];

      if (me.arrayRecetaDetalles.length > 0) {
        me.arrayReceta.push({
          numero: me.numeroreceta,
          listaRecetaDetalles: me.arrayRecetaDetalles,
        });
      }

      me.$swal({
        position: "top-end",
        title: "Está seguro de guardar la valoración de la HC ?",
        text: "..",
        //icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar!",
        confirmButtonText: "Si, confirmar!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(url, {
              id: me.codigohcproceso,
              historiaclinicaId: me.codigohc,
              valoracion: me.valoracion,
              tratamiento: me.tratamiento,
              tratamientoselect: me.arrayTratamientosAll.toString(),
              recomendaciones: me.recomendaciones,
              agenda: me.agenda,
              fecharegistro: me.fecharegistro.replace("T", " "),

              frecuenciacardica: me.frecuenciacardica,
              tensionarterialsist: me.tensionarterialsist,
              tensionarterialdiast: me.tensionarterialdiast,
              frecuenciarespiratoria: me.frecuenciarespiratoria,
              saturacionoxigeno: me.saturacionoxigeno,
              glucemia: me.glucemia,
              temperatura: me.temperatura,

              peso: me.peso,
              talla: me.talla,
              estatura: me.estatura,
              imc: me.imc,

              usuario: me.usuario,

              listaReceta: me.arrayReceta,
            })
            .then(function (response) {
              var respuesta = response.data;
              console.log(respuesta);
              if (respuesta != "") {
                me.codigohc = respuesta.historiaclinicaId;
                me.estadoValoracion = 1;
                me.listarHCProceso();

                //me.verpagina = 2;
              } else {
                me.$swal({
                  position: "top-end",
                  icon: "warning",
                  title: "Proceso de HC no resgistrado.",
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            })
            .catch(function (error) {
              console.log(error);
              me.$swal({
                position: "top-end",
                icon: "success",
                title: "Proceso de HC no resgistrado. NO HAY CONECCIÓN.. ",
                showConfirmButton: false,
                timer: 3000,
              });
            });
        }
      });
    },

    verHCProcesoUser(formHCP) {
      let me = this;
      console.log(formHCP);
      me.arrayRecetaDetalles = [];
      me.numeroreceta = "";
      me.codigohcproceso = formHCP.id;
      me.valoracion = formHCP.valoracion;
      me.tratamiento = formHCP.tratamiento;
      me.recomendaciones = formHCP.recomendaciones;
      if (formHCP.tratamientoselect != null)
        me.arrayTratamientosAll = formHCP.tratamientoselect.split(",");
      //else
      //me.checkantecedentes = [];

      me.frecuenciacardica = formHCP.frecuenciacardica;
      me.tensionarterialsist = formHCP.tensionarterialsist;
      me.tensionarterialdiast = formHCP.tensionarterialdiast;
      me.frecuenciarespiratoria = formHCP.frecuenciarespiratoria;
      me.saturacionoxigeno = formHCP.saturacionoxigeno;
      me.glucemia = formHCP.glucemia;
      me.temperatura = formHCP.temperatura;

      me.peso = formHCP.peso;
      me.talla = formHCP.talla;
      me.estatura = formHCP.estatura;
      me.imc = formHCP.imc;
      me.fecharegistro = formHCP.fecharegistro;

      me.estadoValoracion = 2;
      if (formHCP.listaReceta.length > 0) {
        for (let i = 0; i < formHCP.listaReceta.length; i++) {
          if (formHCP.listaReceta[i].estado == "ACTIVO") {
            me.numeroreceta = formHCP.listaReceta[i].numero;
            me.arrayRecetaDetalles = formHCP.listaReceta[i].listaRecetaDetalles;
          }
        }
        // me.arrayRecetaDetalles.sort((x, y) => x.id - y.id);
      }
    },

    listarHC() {
      let me = this;
      me.verpagina = 0;
      var url = "";
      if (me.buscarlike != "")
        url = me.http_ + "/APIHC/persona/findPersonaGetHCLike/" + me.buscarlike;
      else url = me.http_ + "/APIHC/persona/personaGetHC";

      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.arrayFormularioAll = response.data;

          me.arrayFormularioFilter = response.data;
          //console.log(me.arrayFormularioFilter);
          //
          me.arrayPromocionesAll_all = response.data;
          me.arrayPromocionesAll = response.data;
          me.arrayPromocionesAll_pag = response.data;
          //console.log(me.arrayPromocionesAll_all.length);
          me.paginasTotal = Math.ceil(
            me.arrayPromocionesAll_all.length / me.obj_per_page
          );
          me.arrayPromocionesAll_ES = response.data;
          me.arrayPromocionesAll_MD = response.data;
          //console.log(me.arrayPromocionesAll_ES);
          //console.log(me.arrayPromocionesAll_MD);
          me.fitrarPromociones(1);
          //
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    generarPDFReceta(frhcp, vloCond) {
      let me = this;
      var url = "";
      var documentoDescarga = "";
      if (vloCond == 0) {
        if (frhcp.listaReceta.length > 0) {
          for (let i = 0; i < frhcp.listaReceta.length; i++) {
            if (frhcp.listaReceta[i].estado == "ACTIVO") {
              me.numeroreceta = frhcp.listaReceta[i].numero;
              //me.arrayRecetaDetalles = frhcp.listaReceta[i].listaRecetaDetalles;
            }
          }
          // me.arrayRecetaDetalles.sort((x, y) => x.id - y.id);
        } else {
          me.$swal({
            title: "No hay Receta",
            text: "No hay Receta",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          });
          return;
        }
        url = me.http_ + "/APIHC/pdf/downloadReceta/" + frhcp.id;
        documentoDescarga =
          me.numeroreceta + "-" + frhcp.fecharegistro + ".pdf";
      }
      if (vloCond == 1) {
        url = me.http_ + "/APIHC/pdf/downloadReceta/" + frhcp.procesohcId;
        documentoDescarga = frhcp.numero + "-" + frhcp.fecha + ".pdf";
      }

      axios
        .get(url, { fileForDownload: documentoDescarga, responseType: "blob" })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", documentoDescarga);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    inactivarReceta(frmR) {
      let me = this;
      var url = me.http_ + "/APIHC/receta/inactivar/" + frmR.id;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.listarReceta();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    activarReceta(frmR) {
      let me = this;
      var url = me.http_ + "/APIHC/receta/activar/" + frmR.id;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          me.listarReceta();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    calcularIMC() {
      let me = this;
      if (me.estatura > 0) {
        me.imc = me.peso / (me.estatura * me.estatura);
        me.imc = me.imc.toFixed(2);
      } else {
        me.imc = 0;
      }
    },

    //
    limpiarCodigos() {
      let me = this;
      me.listaCodigos = me.listaCodigos.trim(); // limpiar espacios en blanco
      me.listaCodigos = me.listaCodigos.replace(/ /g, ""); // limpiar todos espacios en blanco
      me.listaCodigos = me.listaCodigos.replace(/\s+/g, ","); //limpiar espacios en blanco, saltos y tabulacion
    },

    ////////////////////
    async uploadFile(event) {
      let me = this;
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("clave", me.codigohc);
      let url = this.http_ + "/APIHC/hc/upload-file";

      try {
        await axios.post(url, formData);
        me.listarFile();
        console.log("PDF uploaded successfully");
      } catch (error) {
        console.error(error);
      }
    },
    async listarFile() {
      let me = this;
      var url = me.http_ + "/APIHC/hc/listarFile/" + me.codigohc;
      await axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          me.listaFiles = response.data;
          console.log(me.listaFiles);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    descargarFile(archivo) {
      let me = this;
      var url =
        me.http_ + "/APIHC/hc/descargarFile/" + archivo + "/" + me.codigohc;
      var archivof = archivo;
      axios
        .get(url, { fileForDownload: archivof, responseType: "blob" })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", archivof);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async eliminarFile(archivo) {
      let me = this;
      var url =
        me.http_ + "/APIHC/hc/eliminarFile/" + archivo + "/" + me.codigohc;
      await axios
        .get(url)
        .then(function (response) {
          //console.log(response);
          me.listarFile();
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    /////////////////////////////////
    buscarPacienteHC() {
      let me = this;
      var url;
      url = me.http_ + "/APIHC/persona/getPersona/" + me.numdocumento;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //me.arraryBuscarLike = response.data;
          me.codigoPaciente = response.data.id;
          me.apellidos = response.data.apellidos;
          me.nombres = response.data.nombres;
          me.edad = response.data.edad;
          me.genero = response.data.genero;
          me.telefono = response.data.telefono;
          me.celular = response.data.celular;
          me.correo = response.data.correo;
          me.fechanacimiento = response.data.fechanacimiento;
          me.telefonoemergencia = response.data.telefonoemergencia;
          me.arrayHCPacienteAll = response.data.listaHistoriaClinica;
          me.edad = FechaService.calcularEdad(me.fechanacimiento);
          //me.casosPaciente();
          me.listarHCPaciente();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    casosPaciente() {
      let me = this;
      var url;
      url = me.http_ + "/APIHC/hc/findHCGroupPaciente/" + me.codigoPaciente;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //me.arraryBuscarLike = response.data;
          me.arrayHCPacienteAll = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    agregarDetalleReceta() {
      let me = this;
      me.arrayRecetaDetalles.push({
        numeroreceta: me.numeroreceta,
        medicamento: me.medicamento,
        instrucciones: me.instrucciones,
        estado: "ACTIVO",
        usuario: me.usuario,
      });
      me.medicamento = "";
      me.instrucciones = "";
    },
    eliminarDetalleReceta(idx) {
      let me = this;

      for (var i = 0; i < me.arrayRecetaDetalles.length; i++) {
        if (i === idx) {
          me.arrayRecetaDetalles.splice(i, 1);
        }
      }
    },

    fitrarPromociones(page) {
      let me = this;
      //console.log(page);
      me.paginaActiva = page;
      me.current_page_all = page;
      //var listing_table = document.getElementById("TableList");
      //var page_span = document.getElementById("page");
      let arraTmp = [];
      if (page < 1) page = 1;
      if (page > me.totNumPages()) page = me.totNumPages();
      //listing_table.innerHTML = "";
      for (
        var i = (page - 1) * me.obj_per_page;
        i < page * me.obj_per_page;
        i++
      ) {
        //listing_table.innerHTML += obj[i].number + "<br>";
        if (me.arrayPromocionesAll_pag[i] != null) {
          arraTmp.push(me.arrayPromocionesAll_pag[i]);
        }

        //
      }
      //console.log(arraTmp);
      me.arrayPromocionesAll = arraTmp;
    },
    totNumPages() {
      let me = this;
      return Math.ceil(me.arrayPromocionesAll_all.length / me.obj_per_page);
    },
    prevPage() {
      let me = this;
      if (me.current_page_all > 1) {
        me.current_page_all--;
        me.fitrarPromociones(me.current_page_all);
        me.paginaActiva = me.current_page_all;
      }
    },
    nextPage() {
      let me = this;
      if (me.current_page_all < me.totNumPages()) {
        me.current_page_all++;
        me.fitrarPromociones(me.current_page_all);
        me.paginaActiva = me.current_page_all;
      }
    },
    //
    selectEliminarHistorial() {
      let me = this;
      if (me.borrarHistorial) {
        me.fechaInicioAcumulacion = me.fechaInicio;
        me.disabledFecha = true;
      } else {
        me.fechaInicioAcumulacion = "";
        me.disabledFecha = false;
      }
    },
    generarPDFHCT(frm) {
      let me = this;
      var url;
      url =
        me.http_ +
        "/APIHC/hc/generarpdfPaciente/" +
        frm.id +
        "/" +
        frm.numdocumento;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //me.arraryBuscarLike = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    generarPDFHCI(frm) {
      let me = this;
      var url;
      url =
        me.http_ +
        "/APIHC/hc/generarpdfPacienteIndivi/" +
        frm.idpersona +
        "/" +
        frm.numdocumento +
        "/" +
        frm.id;
      axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //me.arraryBuscarLike = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    downloadHCTodo(frp, valor) {
      let me = this;
      var url =
        me.http_ + "/APIHC/pdf/downloadhc/" + frp.numdocumento + "/" + valor;
      var documentoDescarga =
        frp.apellidos + " " + frp.nombres + "-" + valor + ".pdf";
      axios
        .get(url, { fileForDownload: documentoDescarga, responseType: "blob" })
        .then(function (response) {
          var respuesta = response.data;
          console.log(respuesta);

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", documentoDescarga);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    verFormulario(frm) {
      let me = this;
      me.editarHC(frm);
      me.verpagina = 6;
    },
    //////////////
    async validarBackEd() {
      let me = this;
      me.http_ = IPServie.getURL();
      var url = me.http_ + "/APIHC/hc/activar";
      await axios
        .get(url)
        .then(function (response) {
          console.log(response);
          //me.listarFile();
          me.http_ = IPServie.getURL();
          console.log("DE UNA");
          console.log(me.http_);
        })
        .catch(function (error) {
          console.log(error);
          me.http_ = IPServie.getURLNORMAL();
          console.log("ALTERNATIVA");
          console.log(me.http_);
        });
    },
  },
  computed: {
    calcularTPCobro: function () {
      let me = this;
      var resultado = 0.0;
      console.log(me.arrayCobros.length);
      for (var i = 0; i < me.arrayCobros.length; i++) {
        resultado = resultado + me.arrayCobros[i].valor;
      }
      return resultado;
    },
  },
  async mounted() {
    let me = this;
    await me.validarBackEd();
    console.log("CArgando");
    console.log(me.http_);
    await me.cargaParametros();
    me.usuario = localStorage.getItem("userhc");
    me.rol = localStorage.getItem("rolhc");
    console.log("Usuario activo: " + me.usuario + " rol: " + me.rol);
    if (me.usuario == null) {
      this.$router.push("/");
      location.reload();
    }
    //me.usuarioModifica = localStorage.getItem("userf");
  },
  components: {
    TextReaderP,
    TextReaderC,
    TextReaderO,
    TextReaderPr,
    //TextReaderR,
    //TextReaderS,
    TextReaderSc,
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  width: 98%;
}
.mostrar {
  display: list-item !important;
  opacity: 10 !important;
  /*position: absolute !important; */
  /*background-color: #3c29297a !important;*/
}

.card-body {
  font-size: 12px;
  line-height: 25px;
}
.btnNext {
  background: #d4d5d5;
  border: 1px solid rgb(79, 88, 97);
  border-style: double;
  color: rgb(78, 76, 76);
}
.btnNext:hover {
  background: #c4cfe7;
  cursor: pointer;
}
.menuLocal:hover {
  cursor: pointer;
  background: #c4cfe7;
  border: PowderBlue 1px solid;
  opacity: 0.5;
  border-top-right-radius: 10px;
}
.menuLocal:active {
  opacity: 0.5;
  cursor: pointer;
  background: #ecf0f1;
  border-top-right-radius: 10px;
}
</style>

<style>
a.tip {
  border-bottom: 1px dashed;
  text-decoration: none;
}
a.tip:hover {
  cursor: help;
  position: relative;
}
a.tip span {
  display: none;
}
a.tip:hover span {
  border: #c0c0c0 1px dotted;
  /*border-radius: 10px 100px / 120px;*/
  border-radius: 10px;

  padding: 2px 2px 2px 2px;
  display: block;
  z-index: 100;
  background: #f0f0f0 no-repeat 100% 5%;
  left: -100px;
  margin: 20px;
  width: 200px;
  position: absolute;
  top: 10px;
  text-decoration: none;
  font-size: 11px;
}
</style>
